import React, { useState } from 'react';
import './NameModal.css'
function NameModal({ twitterUser, isOpen, onConfirm, anonName, setName, levelID }) {
    const [isSaveButtonDisabled, setSaveButtonDisabled] = useState(!(anonName !== null && anonName.trim()));
    const [tempName, setTempName] = useState(anonName);
    const levelClass = `level-${levelID}`;
    
    if (!isOpen) return null;

    const handleNameChange = (e) => {
        const nameValue = e.target.value;
        setTempName(nameValue);

        if (nameValue.trim()) {
            setSaveButtonDisabled(false);
        } else {
            setSaveButtonDisabled(true);
        }
    }

    if (twitterUser && twitterUser.screen_name) {
        return (
            <div className="nameModalOverlay">
                <div className={`nameModalContent ${levelClass}`}>
                    <h4>Welcome, {twitterUser.screen_name}!</h4>
                    <p>You're signed in with X</p>
                    <div className="buttons-wrapper">
                        <button className={`save-button ${levelClass}`} onClick={() => onConfirm(null)}>Start Game</button>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="nameModalOverlay">
                <div className={`nameModalContent ${levelClass}`}>
                    <h4>Welcome!</h4>
                    <p>Enter a name or play anonymously (no leaderboard):</p>
                    <input 
                        type="text" 
                        value={tempName} 
                        onChange={handleNameChange} 
                        placeholder={levelID === "nakamigo_crush" ? "amigo" : "mfer"}
                        maxLength={20} 
                    />
                    <div className="buttons-wrapper">
                        <button className={`anonymous-button ${levelClass}`} onClick={() => onConfirm(null)}>Start Game Anon</button>
                        <button className={`save-button ${levelClass}`} disabled={isSaveButtonDisabled} onClick={() => onConfirm(tempName)}>Start Game</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default NameModal;
